import React from 'react';
import {Icon} from '@stubhub/bamboo';
import {t} from '@stubhub/bamboo-tokens';

const SearchInputIcon = () => (
  <Icon
    id="SearchIcon__attributes"
    description="Search Icon"
    title="Search Icon"
    name="Search"
    fill={t('color-primary')}
    size="sm"
  />
);

export default SearchInputIcon;
